'use client';

import React from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { bg0 } from '@osmosis/tailwind-ui/styles/background';
import { useContentSize } from '@osmosis/nextjs-components/context/ContentSizeContext';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';

type Props = {
  children: React.ReactNode;
  hideSidebar?: boolean;
};

/**
 * Client wrapper for the answers page grid that switches to CSS Grid
 * based on the content container width instead of the viewport width.
 */
const AnswersGrid = ({ children, hideSidebar }: Props) => {
  const { getClassValue } = useContentSize();

  const layoutClassname = getClassValue({
    defaultClasses: 'block xl:grid',
    breakpoints: { xl: 'grid', base: 'block' },
  });

  return (
    <Box
      style={{
        gridGap: 10,
        gridTemplateAreas: `
        "header header"
        "feature ${!hideSidebar ? 'uppersidebar' : 'feature'}"
        "blocks ${!hideSidebar ? 'uppersidebar' : 'blocks'}"
        `,
        gridTemplateRows: 'auto',
        gridTemplateColumns: 'minmax(0, 1fr) 336px',
        zIndex: 0,
      }}
      data-testid="grid-wrapper"
      className={cn(
        'px-5 lg:px-6 max-w-4/5 m-auto mb-8 lg:mb-16 w-full',
        bg0,
        layoutClassname,
      )}
    >
      {children}
    </Box>
  );
};

export default AnswersGrid;
